'use strict';

var _require = require('lodash'),
    get = _require.get,
    each = _require.each;
/**
 * Compute the `costPerCentGuests` from the current state. If
 * `costPerGuestCents` was overridden in a counteroffer, this will kill the
 * changes.
 *
 * @algorithm
 *    1) If there is no duration for the drink package, dont set `costPerGuestCents`
 *    2) If the duration is less than the drink package's minimum duration, set `costPerGuestCents` to undefined
 *    3) If the duration ends on a non-integral hour value (i.e. 310 minutes), set `costPerGuestCents` to undefined
 *    4) If the duration of the drink package is exactly the minimum value, set `costPerGuestCents` to `priceInCents`
 *    6) If the duration of the drink package exceeds the drink's additional hour fees if they exist.
 *        If they don't and `extraHourFeeInCents` exists, apply it, otherwise set `costPerGuestCents`
 *        to undefined.
 * @sets `costPerCentGuests`
 * @return {Void}
 */


exports.computeCostPerGuestCents = function (drinkRequest) {
  // Step 1
  if (!drinkRequest.selectedDurationMinutes) {
    return;
  }

  // Steps 2-3
  if (drinkRequest.selectedDurationMinutes < drinkRequest.duration || drinkRequest.selectedDurationMinutes % 60) {
    drinkRequest.costPerGuestCents = undefined;
    return;
  }

  // Steps 4-5
  var cost = drinkRequest.priceInCents;
  var timePastPackageDuration = drinkRequest.selectedDurationMinutes - drinkRequest.duration;
  if (timePastPackageDuration) {
    var fees = drinkRequest.additionalHourFees || [];
    var additionalHours = Math.floor(timePastPackageDuration / 60);
    for (var i = 0; i < fees.length && i < additionalHours; ++i) {
      cost += get(fees, i + '.priceInCents', 0);
    }

    var extraHours = additionalHours - fees.length;
    if (extraHours > 0) {
      if (!drinkRequest.extraHourFeeInCents) {
        drinkRequest.costPerGuestCents = undefined;
        return;
      }
      cost += extraHours * drinkRequest.extraHourFeeInCents;
    }
  }

  drinkRequest.costPerGuestCents = cost;
};

exports.initFromDrink = function (drinkRequest, drink, durationMinutes, numGuests) {
  var _drink = drink;
  if (drink.toObject) {
    _drink = drink.toObject({ virtuals: true });
  }

  each(_drink.data, function (value, key) {
    if (key === 'courses') {
      drinkRequest[key] = value.filter(function (course) {
        return course.name && course.description;
      });
    } else {
      drinkRequest[key] = value;
    }
  });
  drinkRequest['isCustom'] = false;
  drinkRequest['_id'] = drink._id;
  drinkRequest['selectedDurationMinutes'] = durationMinutes;
  drinkRequest['numGuests'] = numGuests;
  if (drink.data.payAtTheVenue) {
    drinkRequest['costPerGuestCents'] = 0;
  } else {
    exports.computeCostPerGuestCents(drinkRequest);
  }
};